import type { RightPanelSurface } from "../rightPanelSurface";

/**
 * Which surfaces get a resolved title.
 *
 * A thread can host several browser sessions and each names its own page, but
 * the label resolver describes one session — the active one. Titling every
 * preview surface with it would give three tabs the same name, so only the
 * active surface is titled and the rest keep their generic label.
 *
 * Keyed by surface id rather than by kind: two previews are two surfaces, and a
 * kind-keyed map cannot tell them apart.
 */
export function resolveRightPanelResourceLabels(input: {
  readonly surfaces: readonly RightPanelSurface[];
  readonly activeSurfaceId: string | null;
  readonly activeLabel: string;
}): Readonly<Record<string, string>> {
  const active = input.surfaces.find(
    (surface) => surface.kind === "preview" && surface.id === input.activeSurfaceId,
  );
  return active ? { [active.id]: input.activeLabel } : {};
}
